import { useMutation } from '@tanstack/react-query';
import { AuthService } from '../AuthService';

export const useForgotPasswordMutation = () =>
  useMutation({
    mutationFn: async (data) => {
      const response = await AuthService.forgotPassword(data);
      return response.data;
    },
    onError: (error) => {
      if (error.response) {
        switch (error.response.status) {
          case 400:
            throw new Error('Invalid email address');
          case 404:
            throw new Error('Email not found in our system');
          case 422:
            throw new Error('Invalid email format');
          default:
            throw new Error(
              error.response.data?.message ||
                'An error occurred while processing your request'
            );
        }
      } else if (error.request) {
        throw new Error(
          'Unable to connect to the server. Please check your internet connection'
        );
      }
      throw new Error('An unexpected error occurred');
    },
  });
